import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { searchClients } from "../../../api/services/Client";

const ClientSelect = ({ label, value, onChange, required = false }) => {
  const [inputValue, setInputValue] = useState("");
  const [optionsList, setOptionsList] = useState([]);

  const { data: options = [], isFetching } = useQuery(
    [QK.clients, inputValue],
    () => searchClients(inputValue),
    {
      enabled: !!inputValue,
      keepPreviousData: true,
    }
  );

  // Update options list: include current value if missing
  useEffect(() => {
    if (value) {
      const exists = options.some((opt) => opt.id === value.id);
      setOptionsList(exists ? options : [value, ...options]);
    } else {
      setOptionsList(options);
    }
  }, [options, value]);

  const getOptionLabel = (option) => {
    if (!option) return "";
    return `${option.first_name} ${option.last_name} (${option.area_name || "No Area"})`;
  };

  return (
    <Autocomplete
      options={optionsList}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      isOptionEqualToValue={(option, val) => option.id === val?.id}
      loading={isFetching}
      noOptionsText={
        inputValue.length > 0
          ? "No service users match your search"
          : "Type to search service users"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching ? <CircularProgress color="primary" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ClientSelect;